/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssistantsOverviewGetCompetences200ResponseInnerSubscriptionsInnerItemsInner } from './assistantsOverviewGetCompetences200ResponseInnerSubscriptionsInnerItemsInner';


export interface AssistantsOverviewGetCompetences200ResponseInnerSubscriptionsInner { 
    /**
     * 
     */
    status?: AssistantsOverviewGetCompetences200ResponseInnerSubscriptionsInner.StatusEnum;
    /**
     * 
     */
    subscriptionId?: number;
    /**
     * 
     */
    items?: Array<AssistantsOverviewGetCompetences200ResponseInnerSubscriptionsInnerItemsInner>;
}
export namespace AssistantsOverviewGetCompetences200ResponseInnerSubscriptionsInner {
    export type StatusEnum = 'completed' | 'open';
    export const StatusEnum = {
        Completed: 'completed' as StatusEnum,
        Open: 'open' as StatusEnum
    };
}


